import React from 'react';
import { motion } from 'framer-motion';
import './ServiceCard.css';

const ServiceCard = ({ service, index }) => {
  const cardVariants = {
    offscreen: {
      y: 100,
      opacity: 0,
      rotateX: -45
    },
    onscreen: {
      y: 0,
      opacity: 1,
      rotateX: 0,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8,
        delay: index * 0.15
      }
    },
    hover: {
      y: -15,
      scale: 1.03,
      boxShadow: "0 25px 50px -12px rgba(58, 134, 255, 0.25)",
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    }
  };

  const iconVariants = {
    initial: { scale: 0.8, opacity: 0 },
    animate: { 
      scale: 1, 
      opacity: 1,
      transition: {
        delay: index * 0.15 + 0.3,
        type: "spring",
        stiffness: 200
      }
    },
    hover: {
      rotate: 10,
      scale: 1.1,
      transition: { duration: 0.3 }
    }
  };

  const contentVariants = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: index * 0.15 + 0.5
      }
    }
  };

  const itemVariants = {
    initial: { y: 20, opacity: 0 },
    animate: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 }
    }
  };

  return (
    <motion.div
      className="service-card"
      initial="offscreen"
      whileInView="onscreen"
      whileHover="hover"
      viewport={{ once: true, margin: "-50px" }}
      variants={cardVariants}
    >
      <div className="card-inner">
        <motion.div 
          className="card-icon"
          variants={iconVariants}
          initial="initial"
          animate="animate"
          whileHover="hover"
        >
          <span className="icon">{service.icon}</span>
          <div className="icon-bg"></div>
        </motion.div>
        
        <motion.div 
          className="card-content"
          variants={contentVariants}
          initial="initial"
          animate="animate"
        >
          <motion.h3 variants={itemVariants}>{service.title}</motion.h3>
          <motion.p className="description" variants={itemVariants}>
            {service.description}
          </motion.p>
          
          <motion.ul className="features-list" variants={contentVariants}>
            {service.features.map((feature, i) => (
              <motion.li key={i} variants={itemVariants}>
                <span className="feature-icon">✓</span>
                {feature}
              </motion.li>
            ))}
          </motion.ul>
          
          <motion.div className="card-footer" variants={itemVariants}>
            <button className="learn-more">
              Learn More
              <span className="arrow">→</span>
            </button>
          </motion.div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ServiceCard;